/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceRequest
 */
export interface DeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof DeviceRequest
     */
    comment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceRequest
     */
    isTraceEnabledAttributeSet?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceRequest
     */
    isLightResetAttributeSet?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceRequest
     */
    isFullResetAttributeSet?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceRequest
     */
    isMoveToPreproductionAttributeSet?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceRequest
     */
    isLogHistoryAttributeSet?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceRequest
     */
    tagsIds?: Array<string>;
}

export function DeviceRequestFromJSON(json: any): DeviceRequest {
    return DeviceRequestFromJSONTyped(json, false);
}

export function DeviceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'isTraceEnabledAttributeSet': !exists(json, 'isTraceEnabledAttributeSet') ? undefined : json['isTraceEnabledAttributeSet'],
        'isLightResetAttributeSet': !exists(json, 'isLightResetAttributeSet') ? undefined : json['isLightResetAttributeSet'],
        'isFullResetAttributeSet': !exists(json, 'isFullResetAttributeSet') ? undefined : json['isFullResetAttributeSet'],
        'isMoveToPreproductionAttributeSet': !exists(json, 'isMoveToPreproductionAttributeSet') ? undefined : json['isMoveToPreproductionAttributeSet'],
        'isLogHistoryAttributeSet': !exists(json, 'isLogHistoryAttributeSet') ? undefined : json['isLogHistoryAttributeSet'],
        'tagsIds': !exists(json, 'tagsIds') ? undefined : json['tagsIds'],
    };
}

export function DeviceRequestToJSON(value?: DeviceRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comment': value.comment,
        'isTraceEnabledAttributeSet': value.isTraceEnabledAttributeSet,
        'isLightResetAttributeSet': value.isLightResetAttributeSet,
        'isFullResetAttributeSet': value.isFullResetAttributeSet,
        'isMoveToPreproductionAttributeSet': value.isMoveToPreproductionAttributeSet,
        'isLogHistoryAttributeSet': value.isLogHistoryAttributeSet,
        'tagsIds': value.tagsIds,
    };
}

